import { useCallback } from "react";
import { putPausePlayback, putResumePlayback } from "../../controllers/SpotifyApiController";
import { getPointedDeviceId } from "../../reducers/devices";
import { useDispatch, useSelector } from "react-redux";
import { setPlaybackAction } from "../../actions/disablingProcessesActions";
import { manageTooManyRequestsResponse } from "../../utils/connectionUtils";

export const useResumePause = (playing) => {
    const pointedDeviceId = useSelector(getPointedDeviceId)
    const dispatch = useDispatch();

    return useCallback(() =>
    {
        dispatch(setPlaybackAction(true));

        if(playing)
        {
            putPausePlayback(pointedDeviceId)
                .then(() => {
                    dispatch(setPlaybackAction(false));
                })
                .catch((error) => {
                    dispatch(setPlaybackAction(false));
                    manageTooManyRequestsResponse(error, dispatch);
                    console.error('Error pausing playback: ', error);
                });
        }
        else
        {
            putResumePlayback(pointedDeviceId)
                .then(() => {
                    dispatch(setPlaybackAction(false));
                })
                .catch((error) => {
                    dispatch(setPlaybackAction(false));
                    manageTooManyRequestsResponse(error, dispatch);
                    console.error('Error resuming playback: ', error);
                });
        }

        

    }, [playing, pointedDeviceId, dispatch])
}